import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TetEvents.css';

const TetEvents = () => {
  const navigate = useNavigate();

  const schedule = [
    { day: "Thứ 5, 12-02-2026", title: "Hội Chợ Xuân dành cho người nghèo", time: "19g00" },
    { day: "Thứ 6, 13-02-2026", title: "Lễ kính Thánh Phaolô Lê Văn Lộc - Bổn mạng HĐGX", time: "04g45 - 18g00" },
    { day: "Chúa Nhật, 15-02-2026", title: "Giáo xứ có 4 Thánh lễ", time: "05g00 - 06g30 - 15g30 - 17g00" },
    { day: "Thứ 2, 16-02-2026", title: "Lễ Giao thừa (29 Tết)", time: "18g30 - 20g00" },
    { day: "Thứ 3, 17-02-2026", title: "Cầu bình an năm mới (Mùng 01 Tết)", time: "06g00 - 17g00" },
    { day: "Thứ 4, 18-02-2026", title: "Kính nhớ ông bà tổ tiên (Mùng 02 Tết)", time: "06g00 - 17g00" },
    { day: "Thứ 5, 19-02-2026", title: "Thánh hóa công ăn việc làm (Mùng 03 Tết)", time: "06g00 - 17g00" },
    { day: "Thứ 6, 20-02-2026", title: "Giữ chay và kiêng thịt (Mùng 04 Tết)", time: "06g00 - 17g00 - 18g30" },
    { day: "Chúa Nhật, 22-02-2026", title: "Giáo xứ có 4 Thánh lễ", time: "05g00 - 06g30 - 15g30 - 17g00" },
  ];

  return (
    <div className="tet-events-page">
      <header className="tet-header">
        <button className="tet-back-button" onClick={() => navigate('/')}>← Quay lại</button>
        <br/>
        <h1>CHƯƠNG TRÌNH LỄ XUÂN</h1>
        <p className="zodiac-year">Bính Ngọ</p>
      </header>

      <div className="tet-grid-container">
        {schedule.map((item, index) => (
          <div key={index} className="tet-card">
            <div className="card-header">{item.day}</div>
            <div className="card-body">
              <p className="event-title">{item.title}</p>
              <div className="event-time">{item.time}</div>
            </div>
          </div>
        ))}
      </div>
      
      <footer className="tet-footer-text">Chúc Mừng Năm Mới</footer>
    </div>
  );
};

export default TetEvents;